module.exports = __webpack_public_path__ + "img/yes.dcd06782.png";